import { z } from "zod";

export const RATING_PROMPT_PLATFORM_VALUES = ["ios", "android"] as const;

export const ratingPromptedSchema = z.object({
	platform: z.enum(RATING_PROMPT_PLATFORM_VALUES),
});

export type RatingPromptedPayload = z.infer<typeof ratingPromptedSchema>;
